import { string, struct } from 'io-ts/Decoder';

import { CountryCode } from './CountryCode';

export const RefItem = struct({
	id: CountryCode,
	name: string,
});
